import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.scss';
import FooterWrapper from './components/Footer/Footer';
import HeaderWrapper from './components/Header/Header';
import LatexWrapper from './components/LatexToEquation/LatexToEquation';
import QRCodeWrapper from './components/QRCode/QRCode';
import Balloon from './pages/Balloon/Balloon';
import Book from './pages/Book/Book';
import Countries from './pages/Countries/Countries';
import Cypher from './pages/Cypher/Cypher';
import Faces from './pages/Faces/Faces';
import Gatekeeper from './pages/Gatekeeper/Gatekeeper';
import LockerRoom from './pages/LockerRoom/LockerRoom';
import Mirror from './pages/Mirror/Mirror';
import OriginalRoom from './pages/OriginalRoom/OriginalRoom';
import Sign from './pages/Sign/Sign';
import Wolfgang from './pages/Wolfgang/Wolfgang';

/**
 * App Component
 * Root of the application
 * Configures routing and authentication templates
 * Includes global providers for toast notifications and language translations
 * Handles authenticated and unauthenticated states
 * Displays a not found page for undefined routes
 */
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <div style={{ fontSize: 16 }}>
              <HeaderWrapper />
            </div>
          }
        />
        <Route path="/footer" element={<FooterWrapper />} />
        <Route path="/header" element={<HeaderWrapper />} />
        <Route path="/latex_to_equation" element={<LatexWrapper />} />
        <Route path="/qrcode" element={<QRCodeWrapper />} />

        <Route path="red">
          <Route
            path="balloon"
            element={<Balloon team="red" target="/red/wolfgang" />}
          />
          <Route
            path="wolfgang"
            element={<Wolfgang team="red" target="/red/countries" />}
          />
          <Route
            path="countries"
            element={<Countries team="red" target="/red/sign" />}
          />
          <Route
            path="sign"
            element={<Sign team="red" target="/red/lockerroom" />}
          />
          <Route
            path="lockerroom"
            element={<LockerRoom team="red" target="/red/book" />}
          />
          <Route path="book" element={<Book team="red" />} />
          <Route
            path="cypher"
            element={<Cypher team="red" target="/red/faces" />}
          />
          <Route
            path="faces"
            element={<Faces team="red" target="/red/gatekeeper" />}
          />
          <Route path="gatekeeper" element={<Gatekeeper team="red" />} />
          <Route
            path="mirror"
            element={<Mirror team="red" target="/red/originalroom" />}
          />
          <Route path="originalroom" element={<OriginalRoom team="red" />} />
        </Route>

        <Route path="yellow">
          <Route
            path="balloon"
            element={<Balloon team="yellow" target="/yellow/sign" />}
          />
          <Route
            path="sign"
            element={<Sign team="yellow" target="/yellow/countries" />}
          />
          <Route
            path="countries"
            element={<Countries team="yellow" target="/yellow/gatekeeper" />}
          />
          <Route path="gatekeeper" element={<Gatekeeper team="yellow" />} />
          <Route
            path="mirror"
            element={<Mirror team="yellow" target="/yellow/wolfgang" />}
          />
          <Route
            path="wolfgang"
            element={<Wolfgang team="yellow" target="/yellow/faces" />}
          />
          <Route
            path="faces"
            element={<Faces team="yellow" target="/yellow/book" />}
          />
          <Route path="book" element={<Book team="yellow" />} />
          <Route
            path="cypher"
            element={<Cypher team="yellow" target="/yellow/lockerroom" />}
          />
          <Route
            path="lockerroom"
            element={<LockerRoom team="yellow" target="/yellow/originalroom" />}
          />

          <Route path="originalroom" element={<OriginalRoom team="yellow" />} />
        </Route>

        <Route path="green">
          <Route
            path="balloon"
            element={<Balloon team="green" target="/green/lockerroom" />}
          />
          <Route
            path="lockerroom"
            element={<LockerRoom team="green" target="/green/countries" />}
          />
          <Route
            path="countries"
            element={<Countries team="green" target="/green/sign" />}
          />
          <Route
            path="sign"
            element={<Sign team="green" target="/green/faces" />}
          />
          <Route
            path="faces"
            element={<Faces team="green" target="/green/book" />}
          />
          <Route path="book" element={<Book team="green" />} />
          <Route
            path="cypher"
            element={<Cypher team="green" target="/green/gatekeeper" />}
          />
          <Route path="gatekeeper" element={<Gatekeeper team="green" />} />
          <Route
            path="mirror"
            element={<Mirror team="green" target="/green/wolfgang" />}
          />
          <Route
            path="wolfgang"
            element={<Wolfgang team="green" target="/green/originalroom" />}
          />

          <Route path="originalroom" element={<OriginalRoom team="green" />} />
        </Route>

        <Route path="blue">
          <Route
            path="balloon"
            element={<Balloon team="blue" target="/blue/faces" />}
          />
          <Route
            path="faces"
            element={<Faces team="blue" target="/blue/sign" />}
          />
          <Route
            path="sign"
            element={<Sign team="blue" target="/blue/countries" />}
          />
          <Route
            path="countries"
            element={<Countries team="blue" target="/blue/wolfgang" />}
          />
          <Route
            path="wolfgang"
            element={<Wolfgang team="blue" target="/blue/gatekeeper" />}
          />
          <Route path="gatekeeper" element={<Gatekeeper team="blue" />} />
          <Route
            path="mirror"
            element={<Mirror team="blue" target="/blue/lockerroom" />}
          />
          <Route
            path="lockerroom"
            element={<LockerRoom team="blue" target="/blue/book" />}
          />

          <Route path="book" element={<Book team="blue" />} />
          <Route
            path="cypher"
            element={<Cypher team="blue" target="/blue/originalroom" />}
          />

          <Route path="originalroom" element={<OriginalRoom team="blue" />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
